import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OutlineFlag } from '@mx51/chameleon-icons-core';
import {
  ButtonComponent,
  CheckboxComponent,
  IconButtonComponent,
  IconComponent,
  provideIcons,
} from '@mx51/chameleon-ui-angular';
import { ReleaseFlag } from '@shared/enums/release-flag.enum';
import { EnvironmentVariableService } from '@shared/services/environment-variable.service';
import { ReleaseFlagOverrideService } from '@shared/services/release-flag-override.service';
import { isReleaseFlagEnvironment } from '@shared/utils/release-flag-environments';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  standalone: true,
  selector: 'sd-release-flags',
  templateUrl: './release-flags.component.html',
  imports: [CheckboxComponent, IconButtonComponent, IconComponent, ButtonComponent, CommonModule],
  providers: [
    provideIcons({
      OutlineFlag,
    }),
  ],
})
export class ReleaseFlagsComponent implements OnDestroy, OnInit {
  private readonly unsubscribe$ = new Subject<void>();

  hasReleaseFlags: boolean;
  isVisible = false;
  isMenuOpen = false;
  releaseFlagKeys: string[];

  constructor(
    private activatedRoute: ActivatedRoute,
    private releaseFlagOverrideService: ReleaseFlagOverrideService,
    private environmentVariableService: EnvironmentVariableService,
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {
    this.releaseFlagKeys = Object.keys(ReleaseFlag);
    this.hasReleaseFlags = this.releaseFlagKeys.length > 0;
    this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe((queryParams) => {
      // Never show release flag button in prod
      const { TENANT } = this.environmentVariableService.environmentVariables;

      if (!isReleaseFlagEnvironment(TENANT)) {
        return false;
      }

      if (queryParams?.showreleaseflags === 'true') {
        this.isVisible = true;
      }
    });
  }

  closeClicked(): void {
    this.isMenuOpen = false;
  }

  isFlagEnabled(key: string): boolean {
    return this.releaseFlagOverrideService.isFlagEnabled(ReleaseFlag[key]);
  }

  toggleReleaseFlag(key: string): void {
    this.releaseFlagOverrideService.toggleFlagOverride(ReleaseFlag[key]);
  }
}
